import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FetchHook from "../../Api/FetchHooks";
import { userData, usersData } from "../../Redux/userSlice";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import { Backdrop } from "@mui/material";
import PageLoader from "../../Components/PageLoader";
import TableComponent from "../../Components/TableComponent";
import Page from "../../Components/Page";
import { getUserDetails } from "../../utils/helpers";
import AlertComponent from "../../Components/AlertComponent";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";
import UseServerTable from "../../Hooks/UseServerTable";

const Users = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const users = useSelector((state) => state.usersData);
  const loggedInUser = getUserDetails();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [data, setData] = useState(users.usersData);

  // const [loading, response, request] = FetchHook();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // function to fetch users
  // const fetchUsers = useCallback(async () => {
  //   try {
  //     let props = {
  //       url: "/entity_portal_user",
  //     };

  //     await request(props);
  //   } catch (error) {
  //     console.log("fetch users err", error);

  //     const errorMessage =
  //       error.response?.data?.StatusMessage ??
  //       error.response?.data?.message ??
  //       error.message ??
  //       "An unexpected error occurred. Please try again.";

  //     setSnackbar({
  //       open: true,
  //       severity: "error",
  //       message: errorMessage,
  //     });
  //   }
  // }, []);

  // useEffect(() => {
  //   fetchUsers();
  // }, [fetchUsers]);

  // useEffect(() => {
  //   if (response && response.status === 200) {
  //     dispatch(usersData(response.data.Data));
  //     setData(response.data.Data);
  //   }
  // }, [response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `entity_portal_user`,
    onSuccess: (data) => {
      setData(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    { field: "id", headerName: "Entity Id", width: 180 },
    {
      field: "document_number",
      headerName: "Identification No",
      width: 150,
    },
    {
      field: "fullname",
      headerName: "Full Name",
      valueGetter: (params) => {
        return `${params.row?.first_name ?? null} ${
          params.row?.surname ?? null
        } ${params.row?.other_names ?? null}`;
      },
      width: 200,
    },
    { field: "msisdn", headerName: "Phone No", minWidth: 150 },
    { field: "role", headerName: "Role" },
    { field: "active_status", headerName: "Status" },
    {
      field: "start_date",
      headerName: "Start date",
      minWidth: 200,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
    {
      field: "profile",
      headerName: "Profile",
      renderCell: (row) => (
        <Button
          variant="outlined"
          color="primary"
          style={{ marginLeft: 16, fontWeight: "normal" }}
          onClick={() => {
            navigate("/dashboard/users/user-profile", {
              state: { user: row.row },
            });
            dispatch(userData(row.row));
          }}
        >
          Profile
        </Button>
      ),
      width: 100,
    },
  ];

  return (
    <Page
      title={"Users"}
      actions={
        <Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate("/dashboard/users/create-user")}
            disabled={loggedInUser?.role !== "admin"}
          >
            create user
          </Button>
        </Box>
      }
    >
      {/* HEADER */}
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardContent>
          {data && data.length > 0 ? (
            <TableComponent columns={columns} data={data} {...gridProps} />
          ) : gridProps.loading ? (
            <PageLoader />
          ) : (
            <ErrorDisplay
              message="No data to display!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default Users;
